import { AppShell } from '@mantine/core'
import { useAppDispatch, useAppSelector } from '@hooks/redux'
import { selectAsideOpened, setAsideOpened } from '@redux/site/siteSlice'
import { ShellAside } from './ShellAside'
import { ShellNavigation } from './ShellNavigation'
import { ShellHeader } from './ShellHeader'
import { Outlet } from 'react-router-dom'
import { Footer } from '@components/Footer/Footer'

export const Shell = () => {
  const dispatch = useAppDispatch()
  const asideOpened = useAppSelector(selectAsideOpened)

  const handleToggleAside = () => {
    dispatch(setAsideOpened(!asideOpened))
  }

  return (
    <AppShell
      layout="alt"
      header={{ height: 60 }}
      footer={{ height: 40 }}
      navbar={{ width: 225, breakpoint: 0 }}
      aside={{
        width: 300,
        breakpoint: 'xs',
        collapsed: { desktop: !asideOpened, mobile: !asideOpened },
      }}
      padding="md"
    >
      <AppShell.Header>
        <ShellHeader />
      </AppShell.Header>
      <AppShell.Navbar bg="navbar-blue.9">
        <ShellNavigation toggleAside={handleToggleAside} />
      </AppShell.Navbar>
      <AppShell.Main pt={60} pl={225} pr={0}>
        <Outlet />
      </AppShell.Main>
      <AppShell.Aside p="md">
        <ShellAside />
      </AppShell.Aside>
      <AppShell.Footer p="xs">
        <Footer />
      </AppShell.Footer>
    </AppShell>
  )
}
